/**
 * 侧栏 menuId → vue-router 解析（静态注入页与 DB 动态页并存时优先静态 + enName）。
 */

function pickBestRouteCandidate (candidates, enName, urlKey) {
  if (!candidates || !candidates.length) return null
  if (enName) {
    const enHit = candidates.find(r => r && r.name === enName)
    if (enHit && enHit.name) return enHit
  }
  if (urlKey) {
    const urlHit = candidates.find(r => {
      if (!r) return false
      const pk = String(r.path || '').replace(/^\//, '').replace(/\//g, '-')
      return r.name === urlKey || pk === urlKey
    })
    if (urlHit && urlHit.name) return urlHit
  }
  const staticOnes = candidates.filter(r => r && r.meta && r.meta.isDynamic === false)
  const pool = staticOnes.length ? staticOnes : candidates
  return pool.find(r => r && r.name) || null
}

export function resolveMenuRoute (dynamicMenuRoutes, menu) {
  if (!menu || menu.id == null) return null
  const mid = Number(menu.id)
  const en = menu.enName ? String(menu.enName).trim() : ''
  const urlKey = menu.url && /\S/.test(String(menu.url))
    ? String(menu.url).replace(/^\//, '').replace(/\//g, '-')
    : ''
  const pool = Array.isArray(dynamicMenuRoutes) ? dynamicMenuRoutes : []

  const byId = pool.filter(item => item && item.meta && Number(item.meta.menuId) === mid)
  if (byId.length) {
    const hit = pickBestRouteCandidate(byId, en, urlKey)
    if (hit) return hit
  }

  if (en) {
    const byName = pool.filter(item => item && item.name === en)
    const hit = pickBestRouteCandidate(byName, en, urlKey)
    if (hit) return hit
  }

  if (urlKey) {
    const byUrl = pool.filter(item => {
      if (!item) return false
      const pk = String(item.path || '').replace(/^\//, '').replace(/\//g, '-')
      return item.name === urlKey || pk === urlKey
    })
    const hit = pickBestRouteCandidate(byUrl, en, urlKey)
    if (hit) return hit
  }

  return null
}

/** 注册路由表：同一 menuId 仅保留一条，静态优先（避免 Leo / 车载等同 id 误跳）。 */
export function dedupeRoutesByMenuIdPreferStatic (routes) {
  if (!Array.isArray(routes)) return []
  const best = new Map()
  const noMenuId = []
  for (let i = 0; i < routes.length; i++) {
    const r = routes[i]
    if (!r) continue
    if (!r.meta || r.meta.menuId == null) {
      noMenuId.push(r)
      continue
    }
    const id = Number(r.meta.menuId)
    const prev = best.get(id)
    if (!prev) {
      best.set(id, r)
      continue
    }
    const prevStatic = prev.meta && prev.meta.isDynamic === false
    const curStatic = r.meta && r.meta.isDynamic === false
    if (curStatic && !prevStatic) {
      best.set(id, r)
    }
  }
  return noMenuId.concat(Array.from(best.values()))
}



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/utils/sidebarRouteResolver.js